import { render, staticRenderFns } from "./SignalTag.vue?vue&type=template&id=4c88addc"
import script from "./SignalTag.vue?vue&type=script&lang=js"
export * from "./SignalTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports